import Swiper, { Controller, EffectFade, Pagination, Autoplay } from "swiper";

const heroSliderEls = document.querySelectorAll(".hero.slider");
heroSliderEls.forEach((slider) => {
  const swiperHeroContentEl = slider.querySelector(".swiper-hero-content");
  const swiperHeroImageEl = slider.querySelector(".swiper-hero-image");

  let swiperHeroImage = new Swiper(swiperHeroImageEl, {
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: { delay: 5000 },
    modules: [EffectFade, Controller, Autoplay],
  });

  let swiperHeroContent = new Swiper(swiperHeroContentEl, {
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    controller: swiperHeroImage,
    modules: [EffectFade, Pagination, Controller],
  });

  swiperHeroContent.controller.control = swiperHeroImage;
  swiperHeroImage.controller.control = swiperHeroContent;
});
